module.exports = "/assets/data/cb7d1b1910d36df3c049a4cdecd25fa0-RG4.data.json";